<template>
    <div>
    <center>
        <Header/>
        <h1> Page Not Found!</h1>
        <p>
            <a href="/">Go home?</a>
        </p>
    </center>
        <Footer/>

    </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
export default {
    name: 'NotFound',
        components: {
    Header,
        Footer
},
}

</script>

<style scoped>

center {
    margin: 15vw;
}

h1 {
    color: var(--border);
    font-size: 2em;
}

</style>
